/*
 * Generated from Times-Italic.afm. Do not edit directly.
 * The source AFM metrics were converted to JavaScript; this is a modification.
 * Copyright (c) 1985, 1987, 1989, 1990, 1993, 1997 Adobe Systems Incorporated.  All Rights Reserved.Times is a trademark of Linotype-Hell AG and/or its subsidiaries.
 *
 * This file and the 14 PostScript(R) AFM files it accompanies may be used, copied, and distributed for any purpose and without charge, with or without modification, provided that all copyright notices are retained; that the AFM files are not distributed without this file; that all modifications to this file or any of the AFM files are prominently noted in the modified file(s); and that this paragraph is not modified. Adobe Systems has no responsibility or obligation to support the use of the AFM files.
 */
import glyphNames from './standardGlyphNames.js';
export default {
  name: 'Times-Italic',
  bbox: [-169, -217, 1010, 883],
  ascender: 683,
  descender: -217,
  xHeight: 441,
  capHeight: 653,
  glyphNames,
  glyphWidths: [
    250, 333, 420, 500, 500, 833, 778, 214, 333, 333, 500, 675, 250, 333, 250,
    278, 500, 500, 500, 500, 500, 500, 500, 500, 500, 500, 333, 333, 675, 675,
    675, 500, 920, 611, 611, 667, 722, 611, 611, 722, 722, 333, 444, 667, 556,
    833, 667, 722, 611, 722, 611, 500, 556, 722, 611, 833, 611, 556, 556, 389,
    278, 389, 422, 500, 333, 500, 500, 444, 500, 444, 278, 500, 500, 278, 278,
    444, 278, 722, 500, 500, 500, 500, 389, 389, 278, 500, 444, 667, 444, 444,
    389, 400, 275, 400, 541, 500, 333, 500, 556, 889, 500, 500, 333, 1000, 500,
    333, 944, 556, 333, 333, 556, 556, 350, 500, 889, 333, 980, 389, 333, 667,
    389, 444, 389, 500, 500, 500, 500, 275, 500, 333, 760, 276, 500, 675, 760,
    333, 400, 675, 300, 300, 333, 500, 523, 250, 333, 300, 310, 500, 750, 750,
    750, 500, 611, 611, 611, 611, 611, 611, 889, 667, 611, 611, 611, 611, 333,
    333, 333, 333, 722, 667, 722, 722, 722, 722, 722, 675, 722, 722, 722, 722,
    722, 556, 611, 500, 500, 500, 500, 500, 500, 500, 667, 444, 444, 444, 444,
    444, 278, 278, 278, 278, 500, 500, 500, 500, 500, 500, 500, 675, 500, 500,
    500, 500, 500, 444, 500,
  ],
  kernPairs: [
    -140,
    [2689, 2, 428, 2],
    -135,
    [8182, 2, 2148, 2],
    -129,
    [11622, 2],
    -115,
    [8203, 119, 1, 1, 1, 1, 1],
    -111,
    [
      11675, 4, 10, 105, 1, 1, 1, 1, 1, 4, 1, 8, 1, 1, 1, 1, 2, 5824, 2, 5684,
      107, 109,
    ],
    -105,
    [7149, 1100, 123, 1, 1, 1, 1, 2, 24356, 215, 215, 215, 215, 215],
    -95,
    [7150, 25585, 215, 215, 215, 215, 215],
    -92,
    [
      11245, 4, 10, 105, 1, 1, 1, 1, 1, 4, 9, 1, 1, 1, 1, 2, 449, 2, 51, 4, 10,
      105, 1, 1, 1, 1, 1, 4, 1, 8, 1, 1, 1, 1, 2, 234, 2, 51, 4, 10, 6, 99, 1,
      1, 1, 1, 1, 4, 1, 8, 1, 1, 1, 1, 2, 1, 1, 1, 1, 26460, 2, 51, 4, 10, 6,
      99, 1, 1, 1, 1, 1, 4, 1, 8, 1, 1, 1, 1, 2, 1, 1, 1, 1,
    ],
    -90,
    [10353, 119, 1, 1, 1, 1, 1],
    -80,
    [10385, 4, 10, 105, 1, 1, 1, 1, 1, 3, 1, 1, 1, 7, 1, 1, 1, 1, 2],
    -75,
    [57, 124, 8054, 4, 115, 1, 1, 1, 1, 1, 3, 1, 1, 1],
    -74,
    [
      11192, 1, 1, 73, 2, 124, 244, 46, 12, 112, 12, 1, 1, 1, 446, 60, 124,
      6050, 2, 213, 2, 20209, 60, 124,
    ],
    -71,
    [11802, 3],
    -70,
    [11914, 32, 92],
    -65,
    [11207, 429, 215, 1, 429, 1, 26659, 1],
    -60,
    [11643, 119, 1, 1, 1, 1, 1, 91, 119, 1, 1, 1, 1, 1],
    -55,
    [
      7152, 29, 1, 2, 32, 60, 32, 944, 1262, 1, 623, 119, 1, 1, 1, 1, 1, 944,
      47, 9, 3, 112, 12, 1, 1, 1, 231, 275, 12, 112, 12, 1, 1, 1, 7110, 2, 6878,
      2, 6708, 29, 1, 2, 32, 60, 32, 59, 29, 1, 2, 32, 60, 32, 59, 29, 1, 2, 32,
      60, 32, 59, 29, 1, 2, 32, 60, 32, 59, 29, 1, 2, 32, 60, 32, 59, 29, 1, 2,
      32, 60, 32, 2615, 119, 1, 1, 1, 1, 1, 91, 119, 1, 1, 1, 1, 1, 91, 119, 1,
      1, 1, 1, 1, 91, 119, 1, 1, 1, 1, 1, 91, 119, 1, 1, 1, 1, 1, 306, 119, 1,
      1, 1, 1, 1, 7810, 2,
    ],
    -52,
    [11372, 2, 1, 642, 3, 427, 3, 26657, 3],
    -50,
    [
      7148, 124, 1, 1, 1, 2017, 123, 1, 1, 1, 1, 2, 738, 1, 2, 124, 927, 119, 1,
      1, 1, 1, 1, 951, 119, 1, 1, 1, 1, 1, 20321, 124, 1, 1, 1, 88, 124, 1, 1,
      1, 88, 124, 1, 1, 1, 88, 124, 1, 1, 1, 88, 124, 1, 1, 1, 88, 124, 1, 1, 1,
      2669, 1, 2, 124, 88, 1, 2, 124, 88, 1, 2, 124, 88, 1, 2, 124, 88, 1, 2,
      124, 303, 1, 2, 124, 927, 119, 1, 1, 1, 1, 1,
    ],
    -45,
    [8243, 123, 1, 1, 1, 9340, 123, 1, 1, 1, 1, 2],
    -40,
    [
      55, 7087, 2, 121, 1, 1, 1, 1, 2, 523, 1, 2, 124, 1142, 119, 1, 1, 1, 1, 1,
      137, 6, 4, 32, 81, 1, 1, 1, 1, 2, 1, 1, 1, 1, 1, 699, 4, 636, 6, 117, 1,
      1, 1, 1, 2, 1, 1, 1, 1, 498, 119, 1, 1, 1, 1, 1, 2652, 702, 1950, 6662,
      34, 9175, 2, 121, 1, 1, 1, 1, 2, 86, 2, 121, 1, 1, 1, 1, 2, 86, 2, 121, 1,
      1, 1, 1, 2, 86, 2, 121, 1, 1, 1, 1, 2, 86, 2, 121, 1, 1, 1, 1, 2, 86, 2,
      121, 1, 1, 1, 1, 2, 2671, 4, 211, 4, 211, 4, 211, 4, 211, 4, 426, 4, 192,
      119, 1, 1, 1, 1, 1, 91, 119, 1, 1, 1, 1, 1, 91, 119, 1, 1, 1, 1, 1, 91,
      119, 1, 1, 1, 1, 1, 2494, 215, 215, 215, 1305,
    ],
    -37,
    [
      7147, 57, 2365, 2269, 5859, 1, 1, 2, 10, 110, 1, 1, 1, 1, 14907, 57, 158,
      57, 158, 57, 158, 57, 158, 57, 158, 57,
    ],
    -35,
    [
      54, 7080, 639, 119, 1, 1, 1, 1, 1, 1198, 20, 99, 1, 1, 1, 1, 1, 20, 1, 1,
      1, 72, 123, 1, 1, 1, 23279, 215, 215, 215, 215, 215,
    ],
    -34,
    [11301, 505, 2, 1, 642, 2, 1, 26657, 2, 1],
    -30,
    [
      7130, 124, 2295, 32, 92, 1984, 123, 1, 1, 1, 1, 2, 3138, 32, 92, 8471,
      9196, 124, 91, 124, 91, 124, 91, 124, 91, 124, 91, 124, 7455, 32, 92, 91,
      32, 92, 91, 32, 92, 91, 32, 92,
    ],
    -27,
    [9923, 119, 1, 1, 1, 1, 1, 26321, 119, 1, 1, 1, 1, 1],
    -25,
    [
      7343, 119, 1, 1, 1, 1, 1, 1575, 2, 55, 10, 113, 1, 1, 1, 7, 1, 1, 1, 1, 2,
      2169, 2, 463, 123, 1, 1, 1, 1, 2, 11502, 14, 14550, 2, 213, 2, 213, 2,
      213, 2,
    ],
    -20,
    [
      7180, 124, 1, 1, 1, 2205, 5, 124, 4634, 124, 1, 1, 1, 78, 443, 200, 2520,
      15122, 124, 1, 1, 1, 88, 124, 1, 1, 1, 88, 124, 1, 1, 1, 88, 124, 1, 1, 1,
      88, 124, 1, 1, 1, 88, 124, 1, 1, 1, 7173, 228, 215, 215, 215,
    ],
    -18,
    [
      33, 19, 100, 1, 1, 1, 1, 1, 10647, 1, 2, 124, 296, 123, 1, 1, 1, 1, 2,
      3764,
    ],
    -15,
    [
      12302, 123, 1, 1, 1, 1, 2, 2046, 372, 72, 1, 142, 215, 2416, 119, 1, 1, 1,
      1, 1, 21143, 123, 1, 1, 1, 1, 2, 2046, 157, 72, 1, 142, 72, 1, 142, 72, 1,
      142, 72, 1,
    ],
    -10,
    [
      7363, 124, 1, 1, 1, 3098, 124, 1, 1, 1, 3331, 801, 215, 215, 57, 2, 121,
      1, 1, 1, 734, 10, 10, 32, 71, 1, 1, 1, 7, 1, 1, 1, 1, 2, 5, 718, 15, 642,
      34, 5774, 16110, 215, 215, 215, 215, 215, 586, 215, 215, 215, 1564, 15,
      200, 15, 200, 15, 200, 15, 200, 15, 415, 15,
    ],
    92,
    [15159],
  ],
};
